<template>
	<div v-if="text" class="typo-body-caption text-body-quaternary">
		{{ text }}
	</div>
</template>

<script setup lang="ts">
	import type {ProductInfo} from '@globus/image-overlay';
	import {getProductPriceValidityText} from '~/utils/leaflets';

	type Props = {
		productInfo?: ProductInfo | null;
		validFrom?: string | null;
		validTo?: string | null;
	};

	const props = defineProps<Props>();

	const text = computed(() => getProductPriceValidityText(
		props.productInfo,
		props.validFrom,
		props.validTo,
	));
</script>
